import AgentsHero from "../components/HotelAgentPage/AgentsHero";
import AboutFeatureSection from "../components/Sections/AboutFeatureSection";
import BenefitsAgent from "../components/Sections/benefitsAgent";
import HotelAgent from "/Agents/HotelAgent.png"; // ✅ Import it here
import { Hotel, KeyRound, HeartHandshake,Diamond } from "lucide-react";
import Heart from "/Agents/Heart.png"; // ✅ direct import
import HumanService from "/Agents/HumanService.png"; // ✅ direct import
import { MessageSquare, Coffee, CreditCard, Stars, Smartphone, Gift, ConciergeBell, CalendarClock, Lightbulb, ClipboardList, RotateCcw,Plane,Sparkles  } from "lucide-react";
import LuxuryGrid from "../components/Sections/LuxuryGrid";
import SectionHeader from "../components/Sections/SectionHeader";
import LuxurySection from "../components/Homepage/LuxurySection";
import Framework from "../components/Homepage/Framework";
import TestimonialsSection from "../components/Homepage/TestimonialsSection";
import LetsTalkLuxurySection from "../components/Homepage/LetsTalkLuxurySection";
import AboutValuesSection from "../components/Sections/AboutValuesSection";
import LuxuryCards from "../components/Sections/LuxuryCards";
import Cylinder from "../components/Sections/Cylinder";
import LeftAndRightHeader from "../components/Sections/LeftAndRightHeader";
import AboutPhilosophySection from "../components/AboutPage/AboutPhilosophySection";

const statsData = [
  { id: 1, value: "40%", text: "faster guest response times" },
  { id: 2, value: "2×", text: "higher satisfaction" },
  { id: 3, value: "30%", text: "less staff load" },
  { id: 4, value: "+50%", text: "repeat guests" },
];

const afterDepartureCards = [
  {
    id: 1,
    icon: MessageSquare,
    title: "Personalized Thank-You",
    text: "Sends thoughtful, human-like messages after every stay — a graceful way to end each visit and leave guests feeling appreciated.",
  },
  {
    id: 2,
    icon: Diamond,
    title: "Elegant Feedback",
    text: "Collects insights through natural conversation, turning feedback into meaningful data without ever feeling like a survey.",
  },
  {
    id: 3,
    icon: Gift,
    title: "Loyalty Invitations",
    text: "Invites guests to exclusive offers and loyalty programs tailored to their preferences — making every message feel personal and rewarding.",
  },
  {
    id: 4,
    icon: RotateCcw,
    title: "Return Reminders",
    text: "Reaches out at the right moment with subtle, personalized invitations to return — keeping your brand top of mind, effortlessly.",
  },
];
const gridItems = [
  {
    id: 1,
    icon: MessageSquare,
    title: "WhatsApp Check-In",
    text: "Guests check in instantly via chat — no queues, no paperwork, just smooth digital verification and immediate room access.",
  },
  {
    id: 2,
    icon: Coffee,
    title: "Ordering Room Service",
    text: "Guests explore the digital menu, place orders directly through WhatsApp, and receive real-time delivery status updates.",
  },
  {
    id: 3,
    icon: CalendarClock,
    title: "Booking Waiting List",
    text: "AI Squared automatically manages waiting lists, notifying guests as soon as rooms become available with effortless confirmation.",
  },
  {
    id: 4,
    icon: ConciergeBell,
    title: "Concierge & Spa Bookings",
    text: "Guests instantly reserve spa treatments, massages, and concierge services through WhatsApp — no apps or forms needed.",
  },
  {
    id: 5,
    icon: CreditCard,
    title: "Payments & Billing",
    text: "Digital invoices are sent directly to guests, who can securely pay through chat and receive immediate receipts.",
  },
  {
    id: 6,
    icon: Stars,
    title: "Reviews Collection",
    text: "After checkout, AI Squared sends a warm, conversational message inviting guest feedback and collecting valuable insights.",
  },
  {
    id: 7,
    icon: Coffee,
    title: "Pre-Order Meals",
    text: "Guests can pre-select breakfast, lunch, or dinner preferences ahead of time, ensuring seamless personalized service.",
  },
  {
    id: 8,
    icon: Gift,
    title: "Marketing & Loyalty",
    text: "AI Squared sends tailored offers, stay reminders, and loyalty rewards that feel personal and aligned with each guest’s taste.",
  },
  {
    id: 9,
    icon: Smartphone,
    title: "Virtual Receptionist",
    text: "Your always-on assistant that answers every guest inquiry, any time of day, perfectly reflecting your hotel’s tone.",
  },
  {
    id: 10,
    icon: HeartHandshake,
    title: "VIP Recognition",
    text: "AI Squared detects returning or VIP guests, instantly adapting responses and recommending exclusive upgrades or perks.",
  },
  {
    id: 11,
    icon: Lightbulb,
    title: "Smart In-Room Assistant",
    text: "Guests can ask anything — from towel requests to breakfast times — and receive instant, natural responses.",
  },
  {
    id: 12,
    icon: ClipboardList,
    title: "Maintenance Alerts",
    text: "Automatically logs guest-reported issues and alerts your maintenance team instantly for quick, silent resolution.",
  },
];

const stayBenefits = [
  {
    id: 1,
    icon: Hotel,
    title: "Smart Booking",
    text: "Handles inquiries, compares rooms, confirms instantly.",
  },
  {
    id: 2,
    icon: KeyRound,
    title: "Pre-Arrival Check-In",
    text: "Guests verify identity and receive digital keys before arrival.",
  },
  {
    id: 3,
    icon: HeartHandshake,
    title: "Preference Memory",
    text: "AI recalls favorite rooms, pillows, or dining times.",
  },
];

export default function AboutPage() {
  return (
    <>
      <AgentsHero
        badge="AI Squared Hotel Agent"
        title="Where Hospitality Meets Intelligence."
        subtitle="From booking to checkout and beyond, AI Squared perfects every step — your 24/7 concierge that listens, learns, and cares through WhatsApp."
        primaryButton="Explore Agents"
        secondaryButton="Book a Demo"
        image={HotelAgent} // ✅ Use imported variable
      />
      <BenefitsAgent
  title="Every Stay Begins Before the Door Opens"
  subtitle="AI Squared connects with guests the moment they think of booking. Through WhatsApp, it assists with reservations, waiting lists, and pre-arrival personalization."
  tagline="The stay begins with confidence, not confirmation numbers."
  items={stayBenefits}
/>


<div className="leftRight">
<AboutFeatureSection
  tag="Luxury That Listens"
  icon={<Diamond size={18} color="#00ffff" />}
  title="The Essence of"
  highlighted="Effortless Hospitality"
  description={`AI Squared Hotel Agent isn’t a chatbot. It’s your digital concierge — a system fluent in tone, timing, and human warmth. Every message feels handcrafted; every interaction deepens loyalty.`}
  points={[
    { title: "Personalized responses that mirror your brand voice", description: "" },
    { title: "Contextual intelligence anticipating needs", description: "" },
    { title: "Continuous learning for seamless refinement", description: "" },
  ]}
/>

    <img src={Heart} alt="Agent hero" className="hero-image" />

  </div>


  <div className="upDown">
      <SectionHeader
  title={`All Through WhatsApp<br>
One Agent. Seventeen Roles. Infinite Refinement.`}
  subtitle={`AI Squared centralizes every guest interaction — from check-in to check-out — in one seamless, familiar chat. No downloads. No delays. Just hospitality that flows.`}
/>
      <LuxuryGrid items={gridItems} />
</div>

<div className="leftRight hotelAgent">
  <AboutValuesSection
  tag="After Departure"
  icon={<Plane />} 
  values={[
    {
      title: "Luxury That Follows Up, Not Fades Away",
      description: `
        AI Squared extends the conversation even after checkout — maintaining your brand’s warmth and presence.<br/><br/>
        Guests don’t leave your brand — they stay in its memory.
      `,
    },
  ]}
/>

      <LuxuryCards cards={afterDepartureCards} />

</div>

  <div className="upDown hotelAgent">
<LeftAndRightHeader
  badge={<Sparkles size={18} color="#00ffff" />}
  badgeLabel='Luxury Impact'

  leftTitle="The Invisible Hand of Luxury"
  rightText="Technology should whisper, not shout — and AI Squared makes that whisper feel like care."
/>

      <Cylinder items={statsData} />

</div>

<AboutPhilosophySection
  mission={{
    tag: "For Management",
    icon: <i className="fa-solid fa-briefcase"></i>, // 💼
    title: "Redefining Hospitality Through",
    highlighted: "Luxury Intelligence",
    description:
      "AI Squared unifies guest communication, predicts operational needs, and maintains your brand’s signature tone across every channel.",
    points: [
      {
        title: "Unified Communication Hub",
        description:
          "One platform for every guest message, inquiry, and request.",
      },
      {
        title: "Predictive Insights",
        description:
          "Anticipates patterns, optimizes resources, and elevates decision-making.",
      },
      {
        title: "Consistent Tone Across Channels",
        description:
          "Maintains your brand voice — polished, warm, and human — across WhatsApp, email, and in-room chat.",
      },
    ],
  }}
  vision={{
    tag: "For Guests",
    icon: <i className="fa-solid fa-gem"></i>, // 💎
    title: "Where Service",
    highlighted: "Feels Effortless",
    description:
      "Every conversation feels natural, personal, and seamless — transforming hospitality into a human-centred digital experience.",
    points: [
      {
        title: "Natural WhatsApp Interactions",
        description:
          "Guests chat as they normally would — AI Squared responds instantly and gracefully.",
      },
      {
        title: "Personalized Offers & Follow-Ups",
        description:
          "Suggests spa sessions, dining, or upgrades — never pushy, always intuitive.",
      },
      {
        title: "Seamless Journey",
        description:
          "From check-in to checkout, one fluid experience — no app downloads, no friction, no waiting.",
      },
    ],
  }}
  values={{
    tag: "For Staff",
    icon: <i className="fa-solid fa-users-gear"></i>, // 🧑‍💼⚙️
    title: "Empowering People,",
    highlighted: "Not Replacing Them",
    description:
      "AI Squared empowers teams to focus on human touch — automating coordination, reporting, and routine service tasks.",
    points: [
      {
        title: "Smart Alerts & Coordination",
        description:
          "Automatically routes requests to the right department in real time.",
      },
      {
        title: "Task Management & Maintenance Tracking",
        description:
          "Keeps operations running smoothly, from Room Service to repairs.",
      },
      {
        title: "Performance Visibility",
        description:
          "Gives management and staff instant clarity on service flow and guest satisfaction.",
      },
    ],
  }}
  rightImages={[
    "/About/HotelConcierge.png",
    "/About/hotel-room.png",
  ]}
/>

  <div className="upDown hotelAgent">
<LeftAndRightHeader
  badge={<Sparkles size={18} color="#00ffff" />}
  badgeLabel='Luxury Impact'

  leftTitle="Luxury isn’t what you give — it’s how it feels"
  rightText="AI Squared doesn’t replace your staff — it amplifies their humanity. It removes friction, leaving only care."
/>
<div className="centerimage">
    <img src={HumanService} alt="A hotel concierge wearing a black tuxedo and bow tie smiles while holding a service bell. Beside him, a glowing digital silhouette represents AI assistance, with floating chat bubbles saying “Your room is ready” and “Would you like to book a massage?”, along with futuristic data icons — symbolizing harmony between human hospitality and artificial intelligence." className="conc-image" />
</div>
</div>

<LuxurySection/>
<Framework/>
<TestimonialsSection/>
<LetsTalkLuxurySection/>
    </>
  );
}
